import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const [hours, minutes, seconds] = value.split(':');
    const formattedSeconds = seconds.split('.')[0]; // Remove milliseconds

    const parts = [];
    if (hours !== '00') parts.push(`${parseInt(hours, 10)} hours`);
    if (minutes !== '00') parts.push(`${parseInt(minutes, 10)} minutes`);
    if (formattedSeconds !== '00') parts.push(`${parseInt(formattedSeconds, 10)} seconds`);

    return parts.join(', ');
  }
}
